import { z } from 'zod'
import { toTypedSchema } from '@vee-validate/zod'

const validations = {
  string: (errorMessage) => z.string().nonempty(errorMessage),
  select: (errorMessage) =>
    z
      .string()
      .nullable()
      .refine((val) => val !== null && val !== '', {
        message: errorMessage,
      }),
  stringWithMaxLength: (errorMessage, maxLength) =>
    z.string().nonempty(errorMessage).max(maxLength, `Máximo de ${maxLength} caracteres`),
}

export const createCustomTemplateFormSchema = (t) =>
  toTypedSchema(
    z.object({
      specialtyTemplate: validations.select(t('validation.required')),
      templateTitle: validations.stringWithMaxLength(t('validation.required'), 50),
      templatePrompt: validations.string(t('validation.required')),
    }),
  )

export const createCustomTemplateFormSchemaModeCreate = (t) =>
  toTypedSchema(
    z.object({
      templateTitle: validations.stringWithMaxLength(t('validation.required'), 50),
      templatePrompt: validations.string(t('validation.required')),
    }),
  )
